// extracted by mini-css-extract-plugin
export var button = "_oq-0";